import { NotePencilSVG } from 'common/assets';
import stylesColors from 'common/styles/styles.colors';
import { Input } from 'components/elements';
import { useFormState } from 'components/elements/form';
import Text from 'components/elements/text';
import useDrawer from 'hooks/use-drawer';
import { CardSection, SeparatorVertical } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import ScheduleCruiseTable from './cruise-table';
import ReminderDrawer from './reminder-drawer';
import { ScheduleCardHeader, ScheduleCardHeaderRight } from '../../style';

interface Props {
  parentIndex: number;
}

export default function CruiseCard(props: Props) {
  const { t } = useTranslation();
  const { editable } = useFormState();
  const drawer = useDrawer();
  const methods = useFormContext();
  const { clearErrors, setValue, getValues } = methods;

  const onCloseReminder = React.useCallback(
    (onClose?: () => void) => {
      if (!getValues(`cruiseSales.${props.parentIndex}.reminderDate`)) {
        setValue(`cruiseSales.${props.parentIndex}.reminder`, false);
      }
      onClose?.();
    },
    [getValues, props.parentIndex, setValue],
  );

  const onOpenReminderDrawer = React.useCallback(() => {
    drawer.showCustom({
      backdropClose: true,
      onBackdropClose: onCloseReminder,
      render: (close) => (
        <ReminderDrawer
          onClose={() => onCloseReminder(close)}
          parentIndex={0}
          parentMethods={methods}
        />
      ),
    });
  }, [drawer, methods, onCloseReminder]);

  const onChecked = React.useCallback(
    (val: boolean) => {
      clearErrors();
      if (val) {
        onOpenReminderDrawer();
      } else {
        setValue(`cruiseSales.${props.parentIndex}.reminderDate`, null, {
          shouldValidate: true,
        });
        setValue(`cruiseSales.${props.parentIndex}.reminderDescription`, null, {
          shouldValidate: true,
        });
      }
    },
    [clearErrors, onOpenReminderDrawer, props.parentIndex, setValue],
  );

  return (
    <CardSection>
      <ScheduleCardHeader>
        <Text variant="HeadingXSmall">{t('ticketSales:cruise_detail')}</Text>
        <ScheduleCardHeaderRight style={{ alignItems: 'center', gap: '16px' }}>
          <Input
            type="check-box"
            name={`cruiseSales.${props.parentIndex}.reminder`}
            label={t('ticketSales:set_reminder')}
            noMargin
            onAfterChange={onChecked}
          />
          {editable && (
            <NotePencilSVG
              size={20}
              color={stylesColors.primaryDefault}
              onClick={onOpenReminderDrawer}
              cursor="pointer"
            />
          )}
          {/* <SeparatorHorizontal $margin={24} />
          <Input
            type="text"
            name={`cruiseSales.${props.parentIndex}.bookingCode`}
            label={t('ticketSales:reservation_number')}
            labelPlacement={TextLabelPlacementEnum.Left}
            placeholder={t('ticketSales:reservation_number')}
            hideRequiredStar
            noMargin
          /> */}
        </ScheduleCardHeaderRight>
      </ScheduleCardHeader>
      <SeparatorVertical $margin={22}>
        <div style={{ height: 2 }} />
      </SeparatorVertical>
      <ScheduleCruiseTable parentIndex={props.parentIndex} />
    </CardSection>
  );
}
